const Activity = () => import('@/pages/activity/Activity');
const carActivity = () => import('@/pages/activity/carActivity');
const audicarActivity = () => import('@/pages/activity/audicarActivity');
const activiyReserveCarInsu = () => import('@/pages/activity/ActivityReserveCarInsu');
const activityReservePetInsu = () => import('@/pages/activity/ActivityReservePetInsu');
export default {
  path: '/activity',
  component: Activity,
  children: [
    {
      path: 'reserveCarInsu',
      name: 'activiyReserveCarInsu',
      component: activiyReserveCarInsu,
      children: [
        {
          path: 'reserve',
          name: 'activiyReserveCarInsuReserve',
          component: activiyReserveCarInsu,
          props: route => ({
            ...route.params
          }),
          meta: {
            requiresAuth: true
          },
          beforeEnter: (to, from, next) => {
            if(to.params.step) {
              next();
            }else {
              next('/activity/reserveCarInsu');
            }
          }
        }
      ]
    },
    {
    path:'petActivity',
    name: 'activityReservePetInsu',
    component: activityReservePetInsu,
    children: [
      {
        path: 'petreserve',
        name: 'activityReservePetInsuReserve',
        component: activityReservePetInsu,
        props: route => ({
          ...route.params
        }),
        meta: {
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if(to.params.step) {
            next();
          }else {
            next('/activity/petActivity');
          }
        }
      }  
    ]
  },
    {
    path:'audicarActivity',
    name: 'audicarActivity',
    component: audicarActivity,
    children: [
      {
        path: 'audicarreserve',
        name: 'audicarActivityReserve',
        component: audicarActivity,
        props: route => ({
          ...route.params
        }),
        meta: {
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if(to.params.step) {
            next();
          }else {
            next('/activity/audicarActivity');
          }
        }
      }  
    ]
  }  
  ],
}